"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.default = {
    container: {
        display: 'flex',
        borderBottom: `1px solid ${globalStyle_1.default.grey6}`,
        paddingBottom: 10,
        marginTop: 10,
        color: globalStyle_1.default.grey1
    },
    label: {
        width: 175,
        color: globalStyle_1.default.grey4,
        fontSize: 14,
        fontWeight: 400
    },
    value: {
        fontSize: 14,
        color: 'inherit'
    },
    action: {
        textAlign: 'right',
        width: 150,
        fontSize: 14
    },
    edit: {
        color: globalStyle_1.default.indigo3,
        cursor: 'pointer'
    }
};
//# sourceMappingURL=field.style.js.map